var h = Object.defineProperty;
var f = (s, t, e) => t in s ? h(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var a = (s, t, e) => f(s, typeof t != "symbol" ? t + "" : t, e);
import { HttpClient as y, httpClient as n } from "../../httpClient.js";
class k extends y {
  constructor() {
    super(...arguments);
    a(this, "endpoint", "/objectives");
    a(this, "usersEndpoint", "/users");
    a(this, "feedbackEndpoint", "/objective-media-feedback");
  }
  async getOne(e) {
    return n.get(`${this.endpoint}/${e}`);
  }
  async search(e, i = 1, o) {
    return n.get(this.endpoint, {
      params: { searchText: e, page: i, excludeIds: o }
    });
  }
  async create(e) {
    return n.post(this.endpoint, e);
  }
  async update(e, i) {
    return n.put(`${this.endpoint}/${e}`, i);
  }
  async markCompleted(e) {
    return n.post(`${this.usersEndpoint}/complete-objective/${e}`, {});
  }
  async submitMediaFeedback(e) {
    return n.post(this.feedbackEndpoint, e);
  }
  async getUserMediaRating(e, i) {
    return n.get("/user-media-rating", {
      params: { objectiveId: e, mediaId: i }
    });
  }
  async submitMediaRating(e, i, o, r, d, c, p, m, u, b, g) {
    return n.post(this.feedbackEndpoint, {
      objectiveId: e,
      mediaId: i,
      objectiveName: c || "",
      courseName: g || "",
      mediaDescription: p || "",
      mediaNotWorkingComment: "",
      mediaIncorrectComment: "",
      mediaOffensiveComment: "",
      additionalComment: "",
      rating: o,
      mediaUrl: r,
      fileUrl: d,
      userId: m,
      userName: u,
      userEmail: b
    });
  }
}
const C = new k();
export {
  C as default
};
